import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import service from '../../service';
import { RootState } from "..";

const initialState = {
    token: sessionStorage.getItem("token"),
    info: sessionStorage.getItem("info"),
    user: sessionStorage.getItem("user"),
    waitRequest: 0,
}
export const accountLogin = createAsyncThunk("user/accountLogin", async (userInput: any) => {
    try {
        // const res = await service.accountService.Account_Login(userInput);
        // return res;
        return null;
    } catch (err:any) {
        console.log(err);
        alert("服务器报错，请反馈给管理员。")
    }
})
export const fileUpload = createAsyncThunk("user/fileUpload", async (formData: FormData) => {
    try {
        // const res = await service.fileService.File_Upload(formData);
        // return res;
        return {
            path: "/home/user/ecg_backend/upload/A0002"
        };
    } catch (err:any) {
        console.log(err);
        alert("服务器报错，请反馈给管理员。")
    }
})
export const fileMerge = createAsyncThunk("user/fileMerge", async (formData: FormData) => {
    try {
        // const res = await service.fileService.File_Merge(formData);
        // return res;
        return null;
    } catch (err:any) {
        console.log(err);
        alert("服务器报错，请反馈给管理员。")
    }
})
export const fileSegment = createAsyncThunk("user/fileSegment", async (userInput: any) => {
    console.log("fileSegment userInput: ",userInput);
    try {
        const res = await service.onlineService.GET_ARRAY_DATA(userInput);
        return res;
    } catch (err:any) {
        console.log(err);
        alert("服务器报错，请反馈给管理员。")
    }
})
export const fileSample = createAsyncThunk("user/fileSample", async (userInput: any) => {
    try {
        // const res = await service.fileService.File_Sample(userInput);
        // return res;
        return null;
    } catch (err:any) {
        console.log(err);
        alert("服务器报错，请反馈给管理员。")
    }
})
export const accountLogout = createAsyncThunk("user/accountLogout", async () => {
    try {
        // const res = await service.accountService.Account_Logout();
        // return res;
        return null;
    } catch (err:any) {
        console.log(err);
        alert("服务器报错，请反馈给管理员。")
    }
})
export const accountLogoff = createAsyncThunk("user/accountLogoff", async () => {
    try {
        // const res = await service.accountService.Account_Logoff();
        // return res;
        return null;
    } catch (err:any) {
        console.log(err);
        alert("服务器报错，请反馈给管理员。")
    }
})
export const commonCode = createAsyncThunk("user/commonCode", async (formData: FormData) => {
    try {
        // const res = await service.commonService.Common_Code(formData);
        // return res;
        return null;
    } catch (err:any) {
        console.log(err);
        alert("服务器报错，请反馈给管理员。")
    }
})
export const accountRegister = createAsyncThunk("user/accountRegister", async (userInput: any) => {
    try {
        // const res = await service.accountService.Account_Register(userInput);
        // return res;
        return null;
    } catch (err:any) {
        console.log(err);
        alert("服务器报错，请反馈给管理员。")
    }
})
export const userPatientUpdate = createAsyncThunk("user/userPatientUpdate", async (userInput: any) => {
    console.log("userInput: ", userInput)
    try {
        // const res = await service.userService.User_Patient_Update(userInput);
        // return res;
        return null;
    } catch (err:any) {
        console.log(err);
        alert("服务器报错，请反馈给管理员。")
    }
})
export const userDoctorUpdate = createAsyncThunk("user/userDoctorUpdate", async (userInput: any) => {
    console.log("userInput: ", userInput)
    try {
        // const res = await service.userService.User_Doctor_Update(userInput);
        // return res;
        return null;
    } catch (err:any) {
        console.log(err);
        alert("服务器报错，请反馈给管理员。")
    }
})
export const userDeveloperUpdate = createAsyncThunk("user/userDeveloperUpdate", async (userInput: any) => {
    console.log("userInput: ", userInput)
    try {
        const res = await service.userService.User_Developer_Update(userInput);
        return res;
    } catch (err:any) {
        console.log(err);
        alert("服务器报错，请反馈给管理员。")
    }
})
export const userAdminUpdate=createAsyncThunk("user/userAdminUpdate",async(user:any)=>{
    try {
        const res = await service.userService.User_Admin_Update(user);
        return res;
    } catch (err:any) {
        console.log(err);
        alert("服务器报错，请反馈给管理员。")
    }
})
export const userPhone = createAsyncThunk("user/userPhone", async (formData: FormData) => {
    try {
        const res = await service.userService.User_Phone(formData);
        return res;
    } catch (err:any) {
        console.log(err);
        alert("服务器报错，请反馈给管理员。")
    }
})
export const userInfo = createAsyncThunk("user/userInfo", async () => {
    try {
        const res = await service.userService.User_Info();
        return res;
    } catch (err:any) {
        console.log(err);
        alert("服务器报错，请反馈给管理员。")
    }
})
export const commonVerify = createAsyncThunk("user/commonVerify", async (formData: FormData) => {
    try {
        const res = await service.commonService.Common_Verify(formData);
        return res;
    } catch (err:any) {
        console.log(err);
        alert("服务器报错，请反馈给管理员。")
    }
})
export const accountPassword = createAsyncThunk("user/accountPassword", async (formData: FormData) => {
    try {
        const res = await service.accountService.Account_Password(formData);
        return res;
    } catch (err:any) {
        console.log(err);
        alert("服务器报错，请反馈给管理员。")
    }
})
export const commonVerifyCode = createAsyncThunk("user/commonVerifyCode", async (formData: FormData) => {
    try {
        const res = await service.commonService.Common_Verify_Code(formData);
        return res;
    } catch (err:any) {
        console.log(err);
        alert("服务器报错，请反馈给管理员。")
    }
})
export const userDoctorCertify = createAsyncThunk("user/userDoctorCertify", async (formData: FormData) => {
    try {
        const res = await service.userService.User_Doctor_Certify(formData);
        return res;
    }catch (err:any) {
        console.log(err);
        alert("服务器报错，请反馈给管理员。")
    }
})
export const adminList = createAsyncThunk("user/adminList", async ({ category,username,pageNum, pageSize }: any) => {
    try {
        const res = await service.userManageService.Admin_List({category, username,pageNum, pageSize });
        return res;
    } catch (err:any) {
        console.log(err);
        alert("服务器报错，请反馈给管理员。")
    }
})

export const userCertainInfo = createAsyncThunk("user/userCertainInfo", async ({ id, role }: any) => {
    try {
        const res = await service.userService.User_Certain_Info({ id, role });
        return res;
    } catch (err:any) {
        console.log(err);
        alert("服务器报错，请反馈给管理员。")
    }
})

export const adminDoctorAuthenticate = createAsyncThunk("user/adminDoctorAuthenticate", async (formData: FormData) => {
    try {
        const res = await service.userManageService.Admin_Doctor_Authenticate(formData);
        return res;
    } catch (err:any) {
        console.log(err);
        alert("服务器报错，请反馈给管理员。")
    }
})
export const adminDoctorUnauthenticate = createAsyncThunk("user/adminDoctorUnauthenticate", async (formData: FormData) => {
    try {
        const res = await service.userManageService.Admin_Doctor_Unauthenticate(formData);
        return res;
    } catch (err:any) {
        console.log(err);
        alert("服务器报错，请反馈给管理员。")
    }
})
export const adminLock = createAsyncThunk("user/adminLock", async (formData: FormData) => {
    try {
        const res = await service.userManageService.Admin_Lock(formData);
        return res;
    } catch (err:any) {
        console.log(err);
        alert("服务器报错，请反馈给管理员。")
    }
})
export const adminUnlock = createAsyncThunk("user/adminUnlock", async (formData: FormData) => {
    try {
        const res = await service.userManageService.Admin_Unlock(formData);
        return res;
    } catch (err:any) {
        console.log(err);
        alert("服务器报错，请反馈给管理员。")
    }
})
export const adminEnable = createAsyncThunk("user/adminEnable", async (formData: FormData) => {
    try {
        const res = await service.userManageService.Admin_Enable(formData);
        return res;
    } catch (err:any) {
        console.log(err);
        alert("服务器报错，请反馈给管理员。")
    }
})
export const adminDisable = createAsyncThunk("user/adminDisable", async (formData: FormData) => {
    try {
        const res = await service.userManageService.Admin_Disable(formData);
        return res;
    } catch (err:any) {
        console.log(err);
        alert("服务器报错，请反馈给管理员。")
    }
})
export const adminLogout = createAsyncThunk("user/adminLogout", async (formData: FormData) => {
    try {
        const res = await service.userManageService.Admin_Logout(formData);
        return res;
    } catch (err:any) {
        console.log(err);
        alert("服务器报错，请反馈给管理员。")
    }
})
export const adminRestore = createAsyncThunk("user/adminRestore", async (formData: FormData) => {
    try {
        const res = await service.userManageService.Admin_Restore(formData);
        return res;
    } catch (err:any) {
        console.log(err);
        alert("服务器报错，请反馈给管理员。")
    }
})
export const adminAccountExpired = createAsyncThunk("user/adminAccountExpired", async (formData: FormData) => {
    try {
        const res = await service.userManageService.Admin_Account_Expired(formData);
        return res;
    } catch (err:any) {
        console.log(err);
        alert("服务器报错，请反馈给管理员。")
    }
})
export const adminAccountUnexpired = createAsyncThunk("user/adminAccountUnexpired", async (formData: FormData) => {
    try {
        const res = await service.userManageService.Admin_Account_Unexpired(formData);
        return res;
    } catch (err:any) {
        console.log(err);
        alert("服务器报错，请反馈给管理员。")
    }
})
export const adminPasswordExpired = createAsyncThunk("user/adminPasswordExpired", async (formData: FormData) => {
    try {
        const res = await service.userManageService.Admin_Password_Expired(formData);
        return res;
    } catch (err:any) {
        console.log(err);
        alert("服务器报错，请反馈给管理员。")
    }
})
export const adminPasswordUnexpired = createAsyncThunk("user/adminPasswordUnexpired", async (formData: FormData) => {
    try {
        const res = await service.userManageService.Admin_Password_Unexpired(formData);
        return res;
    }catch (err:any) {
        console.log(err);
        alert("服务器报错，请反馈给管理员。")
    }
})
export const userIntegral = createAsyncThunk("user/userIntegral", async () => {
    try {
        const res = await service.userService.User_Integral();
        return res;
    } catch (err:any) {
        console.log(err);
        alert("服务器报错，请反馈给管理员。")
    }
})
export const userDoctorList = createAsyncThunk("user/userDoctorList", async () => {
    try {
        const res = await service.userService.User_Doctor_List();
        return res;
    }catch (err:any) {
        console.log(err);
        alert("服务器报错，请反馈给管理员。")
    }
})
export const userArtificial = createAsyncThunk("user/userArtificial", async (formData: FormData) => {
    try {
        const res = await service.userService.User_Artificial(formData);
        return res;
    }catch (err:any) {
        console.log(err);
        alert("服务器报错，请反馈给管理员。")
    }
})
export const userWaitRequest = createAsyncThunk("user/userWaitRequest", async () => {
    try {
        const res = await service.userService.User_WaitRequest();
        return res;
    } catch (err:any) {
        console.log(err);
        alert("服务器报错，请反馈给管理员。")
    }
})
export const userRequest = createAsyncThunk("user/userRequest", async ({ pageNum, pageSize }: any) => {
    try {
        const res = await service.userService.User_Request({ pageNum, pageSize });
        return res;
    } catch (err:any) {
        console.log(err);
        alert("服务器报错，请反馈给管理员。")
    }
})
export const userCancelRequest=createAsyncThunk("user/userCancelRequest",async (formData:FormData)=>{
    try{
        const res=await service.userService.User_Cancel_Request(formData);
        return res;
    }catch (err:any) {
        console.log(err);
        alert("服务器报错，请反馈给管理员。")
    }
})
export const userRequestAccept = createAsyncThunk("user/userRequestAccept", async (formData: FormData) => {
    try {
        const res = await service.userService.User_Request_Accept(formData);
        return res;
    } catch (err:any) {
        console.log(err);
        alert("服务器报错，请反馈给管理员。")
    }
})
export const userRequestReject = createAsyncThunk("user/userRequestReject", async (formData: FormData) => {
    try {
        const res = await service.userService.User_Request_Reject(formData);
        return res;
    } catch (err:any) {
        console.log(err);
        alert("服务器报错，请反馈给管理员。")
    }
})
export const userHistory=createAsyncThunk("user/userHistory",async ({category,pageNum,pageSize}:any)=>{
    try {
        const res = await service.userService.User_History({category,pageNum,pageSize});
        return res;
    } catch (err:any) {
        console.log(err);
        alert("服务器报错，请反馈给管理员。")
    }
})

export const diagnosisStatic=createAsyncThunk("user/diagnosisStatic",async(formData:FormData)=>{
    try {
        const res = await service.diagnosisService.Diagnosis_Static(formData);
        return res;
    } catch (err:any) {
        console.log(err);
        alert("服务器报错，请反馈给管理员。")
    }
})
export const adminPasswordReset=createAsyncThunk("user/adminPasswordReset",async(formData:FormData)=>{
    try {
        const res = await service.userManageService.Admin_Password_Reset(formData);
        return res;
    } catch (err:any) {
        console.log(err);
        alert("服务器报错，请反馈给管理员。")
    }
})
export const fileInfo=createAsyncThunk("user/fileInfo",async({rawDataId}:any)=>{
    try{
        const res=await service.fileService.File_Info({rawDataId});
        return res;
    }catch (err:any) {
        console.log(err);
        alert("服务器报错，请反馈给管理员。")
    }
})
export const diagnosisReport=createAsyncThunk("user/fileReport",async(formData:FormData)=>{
    try{
        const res=await service.diagnosisService.Diagnosis_Report(formData);
        return res;
    }catch (err:any) {
        console.log(err);
        alert("服务器报错，请反馈给管理员。")
    }
})
export const diagnosisDynamic=createAsyncThunk("user/diagnosisDynamic",async(formData:FormData)=>{
    try{
        const res=await service.diagnosisService.Diagnosis_Dynamic(formData);
        return res;
    }catch (err:any) {
        console.log(err);
        alert("服务器报错，请反馈给管理员。")
    }
})
export const diagnosisDynamicStatus=createAsyncThunk("user/diagnosisDynamicStatus",async({taskId}:any)=>{
    try{
        const res=await service.diagnosisService.Diagnosis_Dynamic_status({taskId});
        return res;
    }catch (err:any) {
        console.log(err);
        alert("服务器报错，请反馈给管理员。")
    }
})
export const diagnosisHistory=createAsyncThunk("user/diagnosisHistory",async({category,pageNum,pageSize}:any)=>{
    try{
        const res=await service.diagnosisService.Diagnosis_History({category,pageNum,pageSize});
        return res;
    }catch (err:any) {
        console.log(err);
        alert("服务器报错，请反馈给管理员。")
    }
})
export const diagnosisDynamicResult=createAsyncThunk("user/diagnosisDynamicResult",async({rawDataId}:any)=>{
    try{
        const res=await service.diagnosisService.Diagnosis_Dynamic_Result({rawDataId});
        return res;
    }catch (err:any) {
        console.log(err);
        alert("服务器报错，请反馈给管理员。")
    }
})
export const diagnosisStaticResult=createAsyncThunk("user/diagnosisStaticResult",async({rawDataId}:any)=>{
    try{
        const res=await service.diagnosisService.Diagnosis_Static_Result({rawDataId});
        return res;
    }catch (err:any) {
        console.log(err);
        alert("服务器报错，请反馈给管理员。")
    }
})
export const adminIntegral=createAsyncThunk("user/adminIntegral",async(formData:FormData)=>{
    try{
        const res=await service.userManageService.Admin_Integral(formData);
        return res;
    }catch (err:any) {
        console.log(err);
        alert("服务器报错，请反馈给管理员。")
    }
})
const userSlice = createSlice({
    name: "userSlice",
    initialState,
    reducers: {},
    extraReducers: builder => {
        builder
            .addCase(accountLogin.fulfilled, (state, { payload }: any) => {
                console.log("payload: ", payload);
                if (payload.data) {
                    state.token = payload.data.token;
                    state.user = payload.data.user;
                    state.info = payload.data.info;
                    console.log("payload.data: ", payload.data)
                    sessionStorage.setItem("token", payload.data.token);
                    sessionStorage.setItem("user", JSON.stringify(payload.data.user));
                    sessionStorage.setItem("info", JSON.stringify(payload.data.info));
                }

            })
            .addCase(accountLogin.pending, (state, { payload }: any) => {
                console.log("pending");
            })
            .addCase(accountLogin.rejected, (state, { payload }: any) => {
                console.log("rejected");
            })
            .addCase(accountLogout.fulfilled, (state, { payload }: any) => {
                state.token = null;
                state.user = null;
                state.info = null;
                sessionStorage.removeItem("token");
                sessionStorage.removeItem("user");
                sessionStorage.removeItem("info");

            })
            .addCase(accountLogout.pending, (state, { payload }: any) => {
                console.log("pending");
            })
            .addCase(accountLogout.rejected, (state, { payload }: any) => {
                console.log("rejected");
            })
            .addCase(accountLogoff.fulfilled, (state, { payload }: any) => {
                state.token = null;
                state.user = null;
                state.info = null;
                sessionStorage.removeItem("token");
                sessionStorage.removeItem("user");
                sessionStorage.removeItem("info");
            })
            .addCase(accountLogoff.pending, (state, { payload }: any) => {
                console.log("pending");
            })
            .addCase(accountLogoff.rejected, (state, { payload }: any) => {
                console.log("rejected");
            })
            .addCase(userWaitRequest.fulfilled, (state, { payload }: any) => {
                    state.waitRequest = payload.data
            })
            .addCase(userWaitRequest.pending,(state, { payload }: any)=>{
                console.log("pending");
            })
            .addCase(userWaitRequest.rejected,(state, { payload }: any)=>{
                console.log("rejected");
            })
    }
})
export const selectWaitRequest=(state:RootState)=>state.userReducer.waitRequest;
export default userSlice.reducer;